import { Link } from 'react-router-dom';
import { latestArticles } from '@/mocks/home';

export default function LatestArticles() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-14">
          <div>
            <span className="inline-block px-4 py-1.5 text-xs font-medium rounded-full bg-accent-50 text-accent-700 mb-4 whitespace-nowrap">
              最新资讯
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900">
              樱境<span className="text-primary-600">物语</span>
            </h2>
          </div>
          <Link
            to="/category/story"
            className="inline-flex items-center gap-2 text-sm font-medium text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 px-3 py-1 text-xs font-medium rounded-full bg-primary-500/90 text-background-50 whitespace-nowrap">
                  {article.category}
                </span>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-400 mb-3">
                  <span>{article.date}</span>
                  <span>·</span>
                  <span>{article.readTime}阅读</span>
                </div>
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}